import React from 'react';
import { mockData } from '../data/mockData';
import * as Icons from 'lucide-react';

const Industries = () => {
  return (
    <section id="services" className="relative py-32 bg-[#121212]">
      <div className="max-w-[1400px] mx-auto px-[7.6923%]">
        {/* Section Header */}
        <div className="text-center mb-20">
          <h2 className="display-large text-white mb-6">
            Industries <span className="text-[#00FFD1]">We Serve</span>
          </h2>
          <p className="body-large text-white/85 max-w-3xl mx-auto">
            From hospitality to healthcare, retail to real estate – we create stunning 
            virtual tours for businesses across all sectors.
          </p>
        </div>

        {/* Industries Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {mockData.industries.map((industry, index) => {
            const IconComponent = Icons[industry.icon];
            return (
              <div
                key={index}
                className="group p-8 bg-white/5 backdrop-blur-sm border border-white/10 hover:border-[#00FFD1]/50 hover:bg-white/10 transition-all duration-400 cursor-pointer"
              >
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-[#00FFD1]/10 flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-400">
                    <IconComponent className="w-6 h-6 text-[#00FFD1]" />
                  </div>
                  <h3 className="heading-3 text-white">{industry.name}</h3>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <p className="body-large text-white/70">
            Don't see your industry? <button className="text-[#00FFD1] hover:underline font-semibold">Contact us</button> – we serve all business types!
          </p>
        </div>
      </div>
    </section>
  );
};

export default Industries;
